import React from 'react';

const WorkingCard = (props) => (
  <div style={{ display: 'flex', flexDirection: 'column' }}>
    <img src={props.icon} alt="how it works" style={{ borderRadius: '10px' }} />
    <p
      style={{
        color: '#0D2059',
        fontFamily: 'var(--font-secondary)',
        fontWeight: 600,
        fontSize: '12px',
        paddingTop: '10px',
      }}
    >
      {props.text}
    </p>
    <p
      style={{
        color: '#465C67',
        fontFamily: 'var(--font-secondary)',
        fontWeight: 500,
        fontSize: '10px',
        paddingTop: '6px',
      }}
    >
      {props.desc}
    </p>
    {/* <p
      style={{
        fontFamily: 'var(--font-secondary)',
        fontWeight: 500,
        fontSize: '10px',
        paddingTop: '6px',
        color: '#3976EA',
      }}
    >
      view more
    </p> */}
  </div>
);

export default WorkingCard;
